import { Button, Col, Row } from "reactstrap";
import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import RotatePhonePopup from "../RotatePhonePopup";
import { useSnackbar } from "../context/SnackbarContext";
import { useLanguage } from "../context/Languagecontext";
import { convertToNativeNumerals } from "../../utils/numberUtils";
import DiceButton from "./DiceButton";

// Language-specific translations for categories and subcategories
const translations = {
    en: {
        friend: {
            0: "Bestie",
            1: "Chaos buddy",
            2: "Party buddy",
            3: "Online buddy",
            4: "School buddy",
            5: "College buddy"
        },
        love: {
            0: "True love",
            1: "Cute love",
            2: "Possessive love",
            3: "Toxic love",
            4: "Ex love",
            5: "One sided love"
        },
        crush: {
            0: "Soft crush",
            1: "Secret crush",
            2: "Vibe crush",
            3: "Insta crush",
            4: "Lowkey crush",
            5: "One sided crush"
        }
    },

    hi: {
        friend: {
            0: "बेस्टी",
            1: "मस्ती वाला दोस्त",
            2: "पार्टी वाला दोस्त",
            3: "ऑनलाइन दोस्त",
            4: "स्कूल दोस्त",
            5: "कॉलेज दोस्त"
        },
        love: {
            0: "सच्चा प्यार",
            1: "प्यारा प्यार",
            2: "पजेसिव प्यार",
            3: "टॉक्सिक प्यार",
            4: "एक्स प्यार",
            5: "एकतरफा प्यार"
        },
        crush: {
            0: "हल्का क्रश",
            1: "सीक्रेट क्रश",
            2: "वाइब वाला क्रश",
            3: "इंस्टा क्रश",
            4: "लोकी क्रश",
            5: "एकतरफा क्रश"
        }
    },

    mr: {
        friend: {
            0: "बेस्ट फ्रेंड",
            1: "मस्ती वाला मित्र",
            2: "पार्टी मित्र",
            3: "ऑनलाइन मित्र",
            4: "शाळेचा मित्र",
            5: "कॉलेज मित्र"
        },
        love: {
            0: "खरे प्रेम",
            1: "गोड प्रेम",
            2: "पझेसिव्ह प्रेम",
            3: "टॉक्सिक प्रेम",
            4: "एक्स प्रेम",
            5: "एकतर्फी प्रेम"
        },
        crush: {
            0: "हलका क्रश",
            1: "सीक्रेट क्रश",
            2: "वाइब क्रश",
            3: "इंस्टा क्रश",
            4: "लोकी क्रश",
            5: "एकतर्फी क्रश"
        }
    },

    hinglish: {
        friend: {
            0: "Bestie",
            1: "Masti wala dost",
            2: "Party dost",
            3: "Online dost",
            4: "School dost",
            5: "College dost"
        },
        love: {
            0: "Sachha pyaar",
            1: "Cute pyaar",
            2: "Possessive pyaar",
            3: "Toxic pyaar",
            4: "Ex pyaar",
            5: "One sided pyaar"
        },
        crush: {
            0: "Soft crush",
            1: "Secret crush",
            2: "Vibe crush",
            3: "Insta crush",
            4: "Lowkey crush",
            5: "One sided crush"
        }
    },

    ta: {
        friend: {
            0: "சிறந்த நண்பன்",
            1: "கலாட்டா நண்பன்",
            2: "பார்ட்டி நண்பன்",
            3: "ஆன்லைன் நண்பன்",
            4: "பள்ளி நண்பன்",
            5: "கல்லூரி நண்பன்"
        },
        love: {
            0: "உண்மையான காதல்",
            1: "அழகான காதல்",
            2: "பொசசிவ் காதல்",
            3: "டாக்ஸிக் காதல்",
            4: "முன்னாள் காதல்",
            5: "ஒருதரப்பு காதல்"
        },
        crush: {
            0: "மென்மையான கிரஷ்",
            1: "ரகசிய கிரஷ்",
            2: "வைப் கிரஷ்",
            3: "இன்ஸ்டா கிரஷ்",
            4: "லோக்கி கிரஷ்",
            5: "ஒருதரப்பு கிரஷ்"
        }
    }
};

const friend = {
    0: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Friend/Bestie.png",
        gradientBg: "linear-gradient(to bottom, #C8C4FF 20%, #DDDAFF 50%)",
        bg: "#A199FF",
        lightBg: "#EDEBFF",
        border: "1px solid #A199FF",
        borderColor: "#5F53FF"
    },
    1: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Friend/Chaosbuddy.png",
        gradientBg: "linear-gradient(to bottom, #99DEFF 20%, #EBF8FF 50%)",
        bg: "#AAE3FF",
        lightBg: "#DFF4FF",
        border: "1px solid #AAE3FF",
        borderColor: "#00AAFF"
    },
    2: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Friend/Partybuddy.png",
        gradientBg: "linear-gradient(to bottom, #FFB67C 20%, #FFE9D7 50%)",
        bg: "#FFA45D",
        lightBg: "#FFF1E5",
        border: "1px solid #FFA45D",
        borderColor: "#F96D00"
    },
    3: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Friend/Onlinebuddy.png",
        gradientBg: "linear-gradient(to bottom, #FF826B 20%, #FFDED7 50%)",
        bg: "#FF826A",
        lightBg: "#FFDED7",
        border: "1px solid #FF826A",
        borderColor: "#FFFFFF"
    },
    4: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Friend/Schoolbuddy.png",
        gradientBg: "linear-gradient(to bottom, #FFBA30 20%, #FFF1CD 50%)",
        bg: "#F4BB47",
        lightBg: "#FFF2D8",
        border: "1px solid #F4BB47",
        borderColor: "#AC7300"
    },
    5: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Friend/Collegebuddy.png",
        gradientBg: "linear-gradient(to bottom, #70B1ED 20%, #CFE6F5 50%)",
        bg: "#70B0ED",
        lightBg: "#CFE6F5",
        border: "1px solid #70B0ED",
        borderColor: "#FFFFFF"
    }
};

const love = {
    0: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Love/Truelove.png",
        gradientBg: "linear-gradient(to bottom, #FFA9CC 20%, #FDBBD6 50%)",
        bg: "#FF78B0",
        lightBg: "#FFF4FA",
        border: "1px solid #FF78B0",
        borderColor: "#FFFFFF"
    },
    1: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Love/Cutelove.png",
        gradientBg: "linear-gradient(to bottom, #F89669 20%, #FFE5D9 50%)",
        bg: "#F89669",
        lightBg: "#FFE8DD",
        border: "1px solid #F89669",
        borderColor: "#A4532E"
    },
    2: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Love/Possessivelove.png",
        gradientBg: "linear-gradient(to bottom, #FFAFA1 20%, #FBDBC6 50%)",
        bg: "#FFAFA1",
        lightBg: "#FFE5E0",
        border: "1px solid #FFAFA1",
        borderColor: "#BE2104"
    },
    3: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Love/Toxiclove.png",
        gradientBg: "linear-gradient(to bottom, #80E5DB 20%, #D4F1EF 50%)",
        bg: "#70D4CA",
        lightBg: "#DBF9F7",
        border: "1px solid #70D4CA",
        borderColor: "#007D6F"
    },
    4: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Love/Exlove.png",
        gradientBg: "linear-gradient(to bottom, #70E5FF 20%, #E0F9FF 50%)",
        bg: "#70E5FF",
        lightBg: "#E0F9FF",
        border: "1px solid #70E5FF",
        borderColor: "#009BBE"
    },
    5: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Love/Onesidedlove.png",
        gradientBg: "linear-gradient(to bottom, #A5DE64 20%, #D2EDB1 50%)",
        bg: "#A5DE65",
        lightBg: "#E0F8C3",
        border: "1px solid #A5DE65",
        borderColor: "#FFFFFF"
    }
};

const crush = {
    0: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Crush/Softcrush.png",
        gradientBg: "linear-gradient(to bottom, #FFA9CC 20%, #FDBBD6 50%)",
        bg: "#FF78B0",
        lightBg: "#FFF4FA",
        border: "1px solid #FF78B0",
        borderColor: "#ffffff"
    },
    1: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Crush/Secretcrush.png",
        gradientBg: "linear-gradient(to bottom, #F89669 20%, #FFE5D9 50%)",
        bg: "#F89669",
        lightBg: "#FFE8DD",
        border: "1px solid #F89669",
        borderColor: "#A4532E"
    },
    2: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Crush/Vibecrush.png",
        gradientBg: "linear-gradient(to bottom, #FFAFA1 20%, #FBDBC6 50%)",
        bg: "#FFAFA1",
        lightBg: "#FFE5E0",
        border: "1px solid #FFAFA1",
        borderColor: "#BE2104"
    },
    3: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Crush/Instacrush.png",
        gradientBg: "linear-gradient(to bottom, #80E5DA 20%, #D4F1EF 50%)",
        bg: "#70D4CA",
        lightBg: "#DBF9F7",
        border: "1px solid #70D4CA",
        borderColor: "#007D6F"
    },
    4: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Crush/Lowkeycrush.png",
        gradientBg: "linear-gradient(to bottom, #70E4FF 20%, #E0F9FF 50%)",
        bg: "#70E5FF",
        lightBg: "#E0F9FF",
        border: "1px solid #70E5FF",
        borderColor: "#009BBE"
    },
    5: {
        image: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question7/CategoryImage/Crush/Onesidedcrush.png",
        gradientBg: "linear-gradient(to bottom, #A4DE64 20%, #D2EDB1 50%)",
        bg: "#A5DE65",
        lightBg: "#E0F8C3",
        border: "1px solid #A5DE65",
        borderColor: "#ffffff"
    }
};

// Category mapping
const categoryMapping = {
    'RnJpZW5k': { data: friend, label: 'friend' },
    'TG92ZQ==': { data: love, label: 'love' },
    'Q3J1c2g=': { data: crush, label: 'crush' }
};

const Category7 = ({ hint, uploadedImage, originalData, username, category }) => {
    const { lanText, t } = useLanguage();
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(() => {
        const saved = sessionStorage.getItem('category7_activeIndex');
        return saved !== null ? parseInt(saved) : 0;
    });
    const [tabContents, setTabContents] = useState(() => {
        const saved = sessionStorage.getItem('category7_tabContents');
        return saved ? JSON.parse(saved) : {};
    });
    const [isShaking, setIsShaking] = useState(false);
    const [keyboardOpen, setKeyboardOpen] = useState(false);
    const [isCheckingConnection, setIsCheckingConnection] = useState(false);

    const textareaRef = useRef(null);
    const scrollTimeoutRef = useRef(null);
    const topRef = useRef(null);
    const swiperRef = useRef(null);

    const { showSnackbar } = useSnackbar();

    const isSmallScreen = window.innerWidth < 380 && window.innerWidth !== 360;
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    const isInAppBrowser = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        return /Instagram|FBAN|FBAV|Messenger|Telegram|Snapchat|Snap/i.test(ua);
    };

    const data = originalData.question;
    const questionText = Array.isArray(data)
        ? data.find(item => item.category === category)?.question || "Pick & Describe the Relationship"
        : "Pick & Describe the Relationship";

    const subCat = Array.isArray(data)
        ? data.find(item => item.category === category)?.answer.subCategory
        : "RnJpZW5k";

    // Get current language (default to 'en' if not supported)
    const currentLanguage = ['en', 'enhi', 'hi', 'mr', 'ta'].includes(lanText) ? lanText : 'en';

    // Get current data object based on subCat from API
    const getCurrentData = () => {
        return categoryMapping[subCat]?.data || friend;
    };

    // Get category type (friend, love, or crush)
    const getCategoryType = () => {
        return categoryMapping[subCat]?.label || 'friend';
    };

    // Get translated name for a specific item
    const getTranslatedName = (index) => {
        const categoryType = getCategoryType();
        return translations[currentLanguage]?.[categoryType]?.[index] ||
            translations['en'][categoryType][index];
    };

    const currentData = getCurrentData();
    const activeItem = currentData[activeIndex];
    const maxLength = 150;

    const userContent = tabContents[activeIndex] || '';
    const typedChars = [...userContent].length;

    const hasContent = userContent.trim().length > 0;
    const isNextButtonDisabled = !hasContent;

    const text = getTranslatedName(activeIndex);

    const getFontSize = (text) => {
        if (!text) return "25px";
        if (text.length <= 10) return "25px";
        if (text.length <= 20) return "20px";
        if (text.length <= 30) return "18px";
        return "16px";
    };

    const triggerShake = () => {
        setIsShaking(true);
        setTimeout(() => setIsShaking(false), 600);
    };

    const checkInternetConnection = async () => {
        await new Promise(resolve => setTimeout(resolve, 400));
        if (!navigator.onLine) {
            return false;
        }
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);

            clearTimeout(timeoutId);
            return true;
        } catch (error) {
            console.log('Network check failed:', error);
            return false;
        }
    };

    const handleFocus = (e) => {
        setKeyboardOpen(true);
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        scrollTimeoutRef.current = setTimeout(() => {
            requestAnimationFrame(() => {
                if (topRef.current) {
                    const element = topRef.current;
                    const rect = element.getBoundingClientRect();
                    const scrollTop = window.scrollY || document.documentElement.scrollTop;
                    const targetY = rect.top + scrollTop;
                    window.scrollTo({
                        top: targetY,
                        behavior: "smooth"
                    });
                }
            });
        }, 100);
    };

    const handleBlur = () => {
        setKeyboardOpen(false);

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };

    const handleContentChange = (e) => {
        const newValue = e.target.value;
        if ([...newValue].length > maxLength) {
            triggerShake();
            return;
        }
        setTabContents(prev => {
            const updated = { ...prev, [activeIndex]: newValue };
            sessionStorage.setItem('category7_tabContents', JSON.stringify(updated));
            return updated;
        });
    };

    const handleTabClick = (index) => {
        setActiveIndex(index);
        sessionStorage.setItem('category7_activeIndex', index);
    };

    const handleNextClick = async () => {
        setIsCheckingConnection(true);

        const isOnline = await checkInternetConnection();

        setIsCheckingConnection(false);

        if (!isOnline) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }

        const formData = {
            originalData,
            hint,
            uploadedImage,
            questionText,
            name: getTranslatedName(activeIndex),
            image: activeItem.image,
            bg: activeItem.bg,
            subCat: subCat,
            gradientBg: activeItem.gradientBg,
            subCategory: getCategoryType().charAt(0).toUpperCase() + getCategoryType().slice(1),
            content: userContent.trim(),
        };

        sessionStorage.setItem('friendFlowData', JSON.stringify(formData));

        navigate(`/${username || ''}/${category || ''}/friendvoice`, {
            replace: false
        });
    };

    useEffect(() => {
        if (swiperRef.current && activeIndex !== 0) {
            setTimeout(() => {
                swiperRef.current.slideTo(activeIndex, 300);
            }, 100); // small delay ensures swiper is fully rendered
        }
    }, [activeIndex]);

    useEffect(() => {
        const isDisabled = isCheckingConnection || keyboardOpen;
        window.dispatchEvent(new CustomEvent('dropdownDisabledState', {
            detail: { disabled: isDisabled }
        }));
    }, [isCheckingConnection, keyboardOpen]);

    return (
        <motion.div
            className='GTRegular'
            animate={{ background: activeItem.gradientBg }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            style={{height : "100dvh"}}
        >
            <div className='h-100 d-flex justify-content-center pt-42'>
                <Row
                    style={{ width: "500px", maxWidth: "100vw", marginTop: keyboardOpen && isAndroid ? "-80px" : "0px", }}>
                    <Col className="p-0 d-flex flex-column" style={{ height: '100%' }}>
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: isSmallScreen ? '65px' : '70px' }}
                        >
                            <div className="text-center" style={{ maxWidth: "90vw" }}>
                                <p
                                    className="text-black lh-sm mx-auto ps-2 m-0 pt-3"
                                    style={{
                                        fontSize: "clamp(16px, 4.5vw, 20px)"
                                    }}
                                >
                                    {t?.friend?.title || "Pick a relationship & describe it anonymously"}
                                </p>
                            </div>
                        </div>

                        <div className="d-flex justify-content-center align-items-center flex-grow-1 w-100 my-2">
                            <div className="h-100 w-100 d-flex justify-content-start align-items-center flex-column">
                                <div className="w-100" style={{ minHeight: '65px' }}>
                                    <Swiper
                                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                                        spaceBetween={0}
                                        slidesPerView="auto"
                                        freeMode={true}
                                        speed={400}
                                        resistance={true}
                                        resistanceRatio={0.85}
                                        followFinger={true}
                                        threshold={5}
                                        touchRatio={1}
                                        touchAngle={45}
                                        grabCursor={true}
                                        centeredSlides={false}
                                        centeredSlidesBounds={false}
                                    >
                                        {Object.values(currentData).map((item, index) => {
                                            const isActive = activeIndex === index;
                                            const itemName = getTranslatedName(index);
                                            return (
                                                <SwiperSlide key={index} style={{ width: "auto" }}>
                                                    <motion.div
                                                        className="d-flex flex-column align-items-center justify-content-between gap-1"
                                                        style={{
                                                            textAlign: "center",
                                                            cursor: "pointer",
                                                            marginLeft: "-1px"
                                                        }}
                                                        onClick={() => handleTabClick(index)}
                                                    >
                                                        {item.image && (
                                                            <motion.img
                                                                src={item.image}
                                                                alt={itemName}
                                                                style={{ width: "35px", height: "35px" }}
                                                                animate={{ scale: isActive ? 1 : 0.9 }}
                                                                transition={{
                                                                    duration: 0.4,
                                                                    ease: [0.4, 0, 0.2, 1]
                                                                }}
                                                            />
                                                        )}

                                                        <div
                                                            className="position-relative"
                                                            style={{
                                                                borderBottom: isActive
                                                                    ? "none"
                                                                    : `2px solid ${currentData[activeIndex].borderColor}`,
                                                                width: "139px",
                                                                height: "27px",
                                                            }}
                                                        >

                                                            <svg
                                                                viewBox="0 0 121 25.5"
                                                                preserveAspectRatio="none"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    display: "block",
                                                                }}
                                                            >
                                                                <path d="M120.186 24.75C104.223 20.4647 114.798 3.1748 99.1693 0.75C75.5417 0.75 46.2058 0.750376 22.5782 0.750376C7.90977 2.67712 16.5472 20.5612 0.185547 24.745"
                                                                    stroke={isActive ? item.borderColor : "transparent"}
                                                                    strokeWidth="2"
                                                                    strokeMiterlimit="2.61313" />
                                                            </svg>


                                                            <p
                                                                className="GTMedium text-balck w-100 px-3"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "58%",
                                                                    left: "50%",
                                                                    transform: "translate(-50%, -50%)",
                                                                    fontSize: "13px",
                                                                    lineHeight: "14px",
                                                                    textAlign: "center",
                                                                    whiteSpace: isActive ? "wrap" : "nowrap",   // 👈 add this
                                                                    overflow: isActive ? "" : "hidden",     // optional (extra text hide karva)
                                                                    textOverflow: "ellipsis" // optional (... show karva)
                                                                }}
                                                            >
                                                                {itemName}
                                                            </p>

                                                        </div>


                                                    </motion.div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>

                                <div ref={topRef} className={`w-100 px-3 mt-4 d-flex justify-content-center flex-grow-1 ${keyboardOpen && isAndroid ? "align-items-start" : "align-items-center"}`}>
                                    <AnimatePresence mode="wait">
                                        <motion.div
                                            key={activeIndex}
                                            className="bg-white rounded-19 d-flex flex-column justify-content-between"
                                            style={{
                                                width: "350px",
                                                maxWidth: "83vw",
                                                height: isSmallScreen ? "300px" : "320px",
                                                boxShadow: "0 0 7.05px 0 rgba(0, 0, 0, 0.25)",
                                            }}
                                            initial={{ opacity: 0, scale: 0.9, y: 20 }}
                                            animate={{ opacity: 1, scale: isSmallScreen ? 0.95 : 1, y: 0 }}
                                            transition={{ duration: 0.4, ease: "easeOut" }}
                                        >
                                            <div
                                                className="rounded-19-top position-relative"
                                                style={{
                                                    background: activeItem.bg,
                                                    height: "100px",
                                                    transition: "background 0.5s ease-in-out"
                                                }}
                                            >
                                                <div className="position-absolute rounded-circle bg-white d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: "90px",
                                                        height: "90px",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                    }}
                                                >
                                                    <div
                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                            background: activeItem.lightBg,
                                                            width: "90%",
                                                            height: "90%",
                                                            transition: "background 0.5s ease-in-out"
                                                        }}
                                                    >
                                                        <motion.img
                                                            src={activeItem.image}
                                                            alt={getTranslatedName(activeIndex)}
                                                            className="img-fluid"
                                                            style={{
                                                                width: "65%",
                                                                height: "65%",
                                                            }}
                                                            initial={{ rotate: -10, scale: 0.8 }}
                                                            animate={{ rotate: 0, scale: 1 }}
                                                            transition={{ duration: 0.5, ease: "easeOut" }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="text-center">
                                                <motion.p
                                                    className="GTMedium mb-3"
                                                    style={{ fontSize: getFontSize(text) }}
                                                    initial={{ opacity: 0, y: -10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.3, delay: 0.1 }}
                                                >
                                                    {text}
                                                </motion.p>

                                                <div
                                                    className={`rounded-4 position-relative mx-auto mb-2 ${isShaking ? 'shake-animation' : ''}`}
                                                    style={{
                                                        background: activeItem.lightBg,
                                                        border: activeItem.border,
                                                        width: "95%",
                                                        transition: "background 0.5s ease-in-out, border 0.5s ease-in-out"
                                                    }}
                                                >
                                                    <div
                                                        className='p-2 pb-2 d-flex align-items-center justify-content-center GTBold text-left'
                                                        style={{
                                                            height: isSmallScreen ? "65px" : "65px",
                                                            fontSize: "19px",
                                                            wordBreak: "break-word",
                                                            overflowWrap: "break-word",
                                                            whiteSpace: "normal",
                                                        }}
                                                    >
                                                        <textarea
                                                            ref={textareaRef}
                                                            value={userContent}
                                                            onChange={handleContentChange}
                                                            onFocus={handleFocus}
                                                            onBlur={handleBlur}
                                                            placeholder={t?.friend?.placeholder || "Describe your relationship"}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    e.preventDefault();
                                                                    textareaRef.current?.blur();
                                                                }
                                                            }}
                                                            enterKeyHint="done"
                                                            className="w-100 h-100 custom-placeholder-7 GTRegular bg-transparent border-0"
                                                            style={{
                                                                resize: "none",
                                                                outline: "none",
                                                                fontSize: "16px",
                                                                textAlign: "start",
                                                                caretColor: activeItem.bg,
                                                            }}
                                                        />




                                                        <DiceButton
                                                            category={category}
                                                            subCategory={getCategoryType().charAt(0).toUpperCase() + getCategoryType().slice(1)}
                                                            onContentFetched={(text) => {
                                                                if ([...text].length > maxLength) return;
                                                                setTabContents(prev => {
                                                                    const updated = { ...prev, [activeIndex]: text };
                                                                    sessionStorage.setItem('category7_tabContents', JSON.stringify(updated));
                                                                    return updated;
                                                                });
                                                            }}
                                                            disabled={isCheckingConnection}
                                                            size="sm"
                                                        />
                                                    </div>
                                                    <p
                                                        className={`text-end pe-5 w-100 mb-2 GTMedium`}
                                                        style={{
                                                            fontSize: "13px",
                                                            color: activeItem.bg,
                                                            transition: "color 0.5s ease-in-out"
                                                        }}
                                                    >
                                                        {convertToNativeNumerals(typedChars, lanText)}/{convertToNativeNumerals(maxLength, lanText)}
                                                    </p>
                                                </div>
                                            </div>
                                        </motion.div>
                                    </AnimatePresence>
                                </div>
                            </div>
                        </div>

                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: isSmallScreen ? '80px' : '110px' }}
                        >
                            <Button
                                onClick={handleNextClick}
                                disabled={isNextButtonDisabled}
                                className="rounded-pill mx-auto GTMedium text-white border-0"
                                style={{
                                    width: "85%",
                                    padding: "14px 1px",
                                    height: "56px",
                                    background: "black",
                                    transform: "scale(0.95)",
                                    opacity: isNextButtonDisabled ? 0.7 : 1,
                                    pointerEvents: (isCheckingConnection && isNextButtonDisabled) ? 'none' : 'auto',
                                    cursor: (isCheckingConnection && isNextButtonDisabled) ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.3s ease',
                                }}
                            >

                                {isCheckingConnection ? (
                                    <>
                                        <div className="custom-spinner" style={{ borderTopColor: "#fff" }} />
                                    </>
                                ) : (
                                    <span className='GTMedium'
                                        style={{
                                            fontSize: "clamp(21px, 4.5vw, 27px)",
                                            lineHeight: 1,
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {t?.common?.next || "Next"}
                                    </span>
                                )}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>

            <RotatePhonePopup
                excludeWhen={[keyboardOpen]}
            />
        </motion.div>
    );
};

export default Category7;